<template>
  <v-toolbar flat fixed class="search-toolbar">
    <v-toolbar-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="lang.items.datatable.search"
        class="search-input"
        single-line
        hide-details
        clearable
      ></v-text-field>
    </v-toolbar-title>
    <v-divider
      class="ml-4"
      inset
      vertical
    ></v-divider>
    <slot></slot>
    <!-- <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          medium
          @click="fullDataReload()"
          :disabled="get_interface.loading"
        >
          <v-icon medium>mdi-refresh</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.app.reload }}</span>
    </v-tooltip> -->
    <v-spacer></v-spacer>
  </v-toolbar>
</template>

<script>
import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  props: {
    filters: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    search: {
      get: function () {
        return this.get_global.search[this.name]
      },
      set: function (newValue) {
        var obj = {}
        obj[this.name] = newValue
        this.$store.dispatch('setGlobalSearch', obj)
      }
    }
  }
}
</script>

<style lang="scss">
.search-toolbar {
  #app & {
    position: relative;
    overflow: visible;
    .v-toolbar__content {
      position: fixed !important;
      width: calc(100% + 14px) !important;
      overflow: visible;
      padding-top: 7.5px;
    }
  }
  #app:not(.mobile) & {
    .v-toolbar__title {
      width: 270px !important;
    }
    .v-toolbar__content {
      height: 65px !important;
    }
  }
  #app.mobile & {
    height: 74px !important;
    .v-toolbar__title {
      width: 270px !important;
    }
    .v-toolbar__content {
      height: 75px !important;
    }
  }
  #app.theme--light & {
    box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.10);
    .v-toolbar__content {
      background: #fff !important;
      box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.10);
    }
  }
  #app.theme--dark & {
    box-shadow: 0 4px 2px -2px rgba(255, 255, 255, 0.09);
    .v-toolbar__content {
      background: #272727 !important;
      box-shadow: 0 4px 2px -2px rgba(255, 255, 255, 0.09);
    }
  }
}
</style>
